import { IoChevronBackOutline } from "react-icons/io5";
import { IoChevronForwardOutline } from "react-icons/io5";
import "./styles.css";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="pagination-container">
      <IoChevronBackOutline
        className="pagination-icon"
        onClick={handlePrevious}
        style={{ color: currentPage === 1 ? "#ADADAD" : "inherit" }}
      />
      <span className="pagination-text">
        Page {currentPage} of {totalPages}
      </span>
      <IoChevronForwardOutline
        className="pagination-icon"
        onClick={handleNext}
        style={{ color: currentPage === totalPages ? "#ADADAD" : "inherit" }}
      />
    </div>
  );
};

export default Pagination;
